module.exports = __webpack_public_path__ + "static/media/unica_extrafina_harinadetrigo(1).b31e573e.png";